// This file contains the user type constants used in the application.
export const USER_TYPE = {
	GUEST: 1,
	INTERN: 3,
	EXTERNAL: 4,
	CONTRACTOR: 5,
	CLEANER: 6,
	UNKNOWN: 7,
	ZEZAMII_USER: 8,
	ACCESS_ONLY_USER: 9
};
